// 客户资料
export const customerDetailsList = [
  { title: '客户资料', name: 'customerInformation' },
  { title: '合同清单', name: 'contractList' },
  { title: '划拨记录', name: 'transferRecord' },
  { title: '提现记录', name: 'withdrawalsRecord' },
  { title: '到款记录', name: 'depositRecord' },
  { title: '特价审批记录', name: 'specialRecord' },
  { title: '坏账记录', name: 'breakRecord' }
  // { title: '协议价', name: 'price' }
]
// 合同清单
export const contractStatusList = [
  { title: '全部', name: 'all' },
  { title: '未签署', name: 'notSigned' },
  { title: '履行中', name: 'transferRecord' },
  { title: '已履行', name: 'withdrawalsRecord' },
  { title: '已作废', name: 'specialRecord' }
]
// 协议价
export const agreementSpiceList = [
  { title: '协议价品牌', name: 'priceBrand' },
  { title: '协议价系列', name: 'priceSeries' },
  { title: '协议价产品', name: 'priceProduct' }
]

// 客户转移列表
export const transferList = [
  { title: '成交客户', name: 'customers' },
  { title: '潜在客户', name: 'potentialCustomers' },
  { title: '休眠客户', name: 'dormantclient' },
  { title: '待审核转移客户', name: 'pendingtransfer' }
]

// 我的客户
export const custormList = [
  { title: '成交客户', name: 'customers' },
  { title: '潜在客户', name: 'potentialCustomers' },
  { title: '休眠客户', name: 'dormantclient' }
]

// 审批
export const specialList = [
  { title: '审批通过', name: 'approvaled' },
  { title: '审批中', name: 'underReview' },
  { title: '审批不通过', name: 'approvalFailed' }
]

// 客户管理设置
export const managementSetList = [
  { title: '基础资料配置', name: 'basicConfig' },
  { title: '客户资料库设置', name: 'customerSet' },
  { title: '星级模块设置', name: 'starModule' },
  { title: '信用模块设置', name: 'creditModule' }
]

// 基础资料配置
export const basicConfigList = [
  { title: '客户类型', name: 'customer_type' },
  { title: '所属行业', name: 'industry_type' },
  { title: '客户来源', name: 'from_type' }
]
// 模板列表模糊条件
export const templateList = [
  { value: 'templateName', label: '模板名称' },
  { value: 'flag', label: '模板状态' }
]
// 协议价模板切换
export const priceList = [
  { title: '协议价品牌', name: 'priceBrand' },
  { title: '协议价系列', name: 'priceseries' },
  { title: '协议价产品', name: 'priceproduct' }
]
// 客户搜索
export const cusNameList = [
  { value: 'cusName', label: '客户名称' }
  // { value: 'money', label: '贸易总额' },
  // { value: 'count', label: '签订合同' },
  // { value: 'badDebt', label: '坏帐' }
]
// 客户特价审批
export const approveSelect = [
  { value: 'cusName', label: '客户名称' },
  { value: 'brandName', label: '品牌' },
  { value: 'seriesName', label: '系列' },
  { value: 'proName', label: '产品名称' },
  { value: 'proModel', label: '型号' },
  { value: 'proOrdernum', label: '订货号' },
  { value: 'specialPrice', label: '审批特价' },
  { value: 'proDiscount', label: '折扣' },
  { value: 'proPrice', label: '产品面价' },
  { value: 'specialDate', label: '价格有效期' },
  { value: 'flag', label: '是否开启' },
  { value: 'createUser', label: '发起人' },
  { value: 'createDate', label: '发起时间' }
  // { value: 'processUser', label: '处理人' },
  // { value: 'processDate', label: '处理时间' }
]
